import { call, put, takeLatest } from 'redux-saga/effects';
import { AnswerTypes } from 'services/api';
import {
  createAnswerType,
  createAnswerTypeSuccess,
  createAnswerTypeFailure,
} from '../../actions';
import { actions as notificationActions } from 'components/Notification';

function* createAnswerTypeSaga(action) {
  try {
    const data = yield call(AnswerTypes.createAnswerType, {
      answerType: action.payload,
    });
    yield put(createAnswerTypeSuccess(data));
    yield put(
      notificationActions.addNotification([
        {
          type: 'success',
          message: { code: 'created', resource: 'answerType' },
        },
      ])
    );
  } catch (e) {
    yield put(createAnswerTypeFailure(e.data));
    yield put(
      notificationActions.addNotification(
        e.data.errors.map(error => ({ type: 'error', message: error.code }))
      )
    );
  }
}

export default () => takeLatest(createAnswerType, createAnswerTypeSaga);
